import { render, staticRenderFns } from "./VC.vue?vue&type=template&id=55f5ab76&"
import script from "./VC.vue?vue&type=script&lang=js&"
export * from "./VC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports